import Vue from 'vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueRouter from 'vue-router'
import store from '@stores/store'
Vue.use(Loading);

let pageLoader;

let routes = [
    {
        path: '/',                                       // all the routes which needs authentication + two factor authentication + lock screen
        component: require('@layouts/default-page').default,
        meta: { validate: ['auth','two_factor','lock_screen','valid_license'] },
        children: [
            {
                path: '/',
                component: require('@views/pages/home').default
            },
            {
                path: '/home',
                component: require('@views/pages/home').default
            },
            {
                path: '/about',
                component: require('@views/pages/about').default
            },
            {
                path: '/update',
                component: require('@views/pages/update').default
            },
            {
                path: '/support',
                component: require('@views/pages/support').default
            },
            {
                path: '/profile',
                component: require('@views/pages/profile').default
            },
            {
                path: '/change-password',
                component: require('@views/pages/change-password').default
            },
            {
                path: '/blank',
                component: require('@views/pages/blank').default
            },
            {
                path: '/configuration',
                component: require('@views/configuration/basic/index').default,
            },
            {
                path: '/configuration/logo',
                component: require('@views/configuration/logo/index').default,
            },
            {
                path: '/configuration/mail',
                component: require('@views/configuration/mail/index').default,
            },
            {
                path: '/backup',
                component: require('@views/backup/index').default
            },
            {
                path: '/configuration/basic',
                component: require('@views/configuration/basic/index').default
            },
            {
                path: '/configuration/system',
                component: require('@views/configuration/system/index').default
            },
            {
                path: '/configuration/role',
                component: require('@views/configuration/role/index').default
            },
            {
                path: '/configuration/menu',
                component: require('@views/configuration/menu/index').default
            },
            {
                path: '/configuration/authentication',
                component: require('@views/configuration/authentication/index').default
            },
            // {
            //     path: '/configuration/sms',
            //     component: require('@views/configuration/sms/index').default
            // },
            {
                path: '/configuration/scheduled-job',
                component: require('@views/configuration/scheduled-job/index').default
            },
            {
                path: '/configuration/ip-filter',
                component: require('@views/configuration/ip-filter/index').default
            },
            {
                path: '/configuration/ip-filter/:id/edit',
                component: require('@views/configuration/ip-filter/edit').default
            },
            {
                path: '/configuration/permission',
                component: require('@views/configuration/permission/index').default
            },
            {
                path: '/configuration/permission/assign',
                component: require('@views/configuration/permission/assign').default
            },
            {
                path: '/configuration/locale',
                component: require('@views/configuration/locale/index').default
            },
            {
                path: '/configuration/locale/:id/edit',
                component: require('@views/configuration/locale/edit').default
            },
            {
                path: '/configuration/locale/:locale',
                component: require('@views/configuration/locale/view').default
            },
            {
                path: '/configuration/locale/:locale/:module',
                component: require('@views/configuration/locale/view').default
            },
            {
                path: '/email-template',
                component: require('@views/email-template/index').default
            },
            {
                path: '/email-template/:id/edit',
                component: require('@views/email-template/edit').default
            },
            {
                path: '/email-log',
                component: require('@views/email-log/index').default
            },
            {
                path: '/activity-log',
                component: require('@views/activity-log/index').default
            },
            {
                path: '/todo',
                component: require('@views/todo/index').default
            },
            {
                path: '/todo/:id/edit',
                component: require('@views/todo/edit').default
            },
            {
                path: '/user',
                component: require('@views/user/index').default
            },
            {
                path: '/user/:id',
                component: require('@views/user/basic').default
            },
            {
                path: '/user/:id/basic',
                component: require('@views/user/basic').default
            },
            {
                path: '/user/:id/contact',
                component: require('@views/user/contact').default
            },
            {
                path: '/user/:id/avatar',
                component: require('@views/user/avatar').default
            },
            {
                path: '/user/:id/social',
                component: require('@views/user/social').default
            },
            {
                path: '/user/:id/password',
                component: require('@views/user/password').default
            },
            {
                path: '/user/:id/email',
                component: require('@views/user/email').default
            },
            {
                path: '/message',
                component: require('@views/message/index').default
            },
            {
                path: '/message/compose',
                component: require('@views/message/index').default
            },
            {
                path: '/message/inbox',
                component: require('@views/message/inbox').default
            },
            {
                path: '/message/sent',
                component: require('@views/message/sent').default
            },
            {
                path: '/message/important',
                component: require('@views/message/important').default
            },
            {
                path: '/message/trash',
                component: require('@views/message/trash').default
            },
            {
                path: '/message/draft',
                component: require('@views/message/draft').default
            },
            {
                path: '/message/:uuid/draft',
                component: require('@views/message/edit-draft').default
            },
            {
                path: '/message/:uuid',
                component: require('@views/message/view').default
            },
            {
                path: '/configuration/question',
                component: require('@views/configuration/question/index').default
            },
            {
                path: '/configuration/task',
                component: require('@views/configuration/task/index').default
            },
            {
                path: '/configuration/task-category/:id/edit',
                component: require('@views/configuration/task/edit-task-category').default
            },
            {
                path: '/configuration/task-priority/:id/edit',
                component: require('@views/configuration/task/edit-task-priority').default
            },
            {
                path: '/department',
                component: require('@views/department/index').default
            },
            {
                path: '/department/:id/edit',
                component: require('@views/department/edit').default
            },
            {
                path: '/designation',
                component: require('@views/designation/index').default
            },
            {
                path: '/designation/:id/edit',
                component: require('@views/designation/edit').default
            },
            {
                path: '/location',
                component: require('@views/location/index').default
            },
            {
                path: '/location/:id/edit',
                component: require('@views/location/edit').default
            },
            {
                path: '/announcement',
                component: require('@views/announcement/index').default
            },
            {
                path: '/announcement/:id/edit',
                component: require('@views/announcement/edit').default
            },
            {
                path: '/task',
                component: require('@views/task/index').default
            },
            {
                path: '/task/create',
                component: require('@views/task/index').default
            },
            {
                path: '/task/:uuid/edit',
                component: require('@views/task/edit').default
            },
            {
                path: '/task/:uuid',
                component: require('@views/task/show').default
            },
            {
                path: '/report/task/summary',
                component: require('@views/task/task-summary').default
            },
            {
                path: '/report/log/summary',
                component: require('@views/user/log-summary').default
            }
        ]
    },
    {
        path: '/',                                       // all the routes which needs authentication + two factor authentication + lock screen
        component: require('@layouts/default-page').default,
        meta: { validate: ['auth','two_factor','lock_screen'] },
        children: [
            {
                path: '/license',
                component: require('@views/license/index').default,
            },
        ]
    },
    {
        path: '/',
        component: require('@layouts/guest-page').default,
        meta: { validate: ['auth'] },
        children: [
            {
                path: '/auth/security',
                component: require('@views/auth/security').default,
            },
            {
                path: '/auth/lock',
                component: require('@views/auth/lock').default,
            },
        ]
    },
    {
        path: '/',                      // all the routes which can be access without authentication
        component: require('@layouts/guest-page').default,
        meta: { validate: ['guest'] },
        children: [
            {
                path: '/',
                component: require('@views/auth/login').default
            },
            {
                path: '/login',
                component: require('@views/auth/login').default
            },
            {
                path: '/password',
                component: require('@views/auth/password').default
            },
            {
                path: '/register',
                component: require('@views/auth/register').default
            },
            {
                path: '/auth/:token/activate',
                component: require('@views/auth/activate').default
            },
            {
                path: '/password/reset/:token',
                component: require('@views/auth/reset').default
            },
            {
                path: '/auth/social',
                component: require('@views/auth/social-auth').default
            },
            {
                path: '/install',
                component: require('@views/install/index').default
            }
        ]
    },
    {
        path: '/',
        component : require('@layouts/guest-page').default,
        children: [
            {
                path: '/terms-and-conditions',
                component: require('@views/pages/terms-and-conditions').default
            }
        ]
    },
    {
        path: '/',
        component : require('@layouts/error-page').default,
        children: [
            {
                path: '/terms-and-conditions',
                component: require('@views/pages/terms-and-conditions').default
            },
            {
                path: '/ip-restricted',
                component: require('@views/errors/ip-restricted').default
            },
            {
                path: '/maintenance',
                component: require('@views/errors/maintenance').default
            }
        ]
    },
    {
        path: '*',
        component : require('@layouts/error-page').default,
        children: [
            {
                path: '*',
                component: require('@views/errors/page-not-found').default
            }
        ]
    }
];

const router = new VueRouter({
    routes,
    // linkActiveClass: 'active',
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

router.beforeEach((to, from, next) => {
    pageLoader = Vue.$loading.show();
    // For force logout
    // store.dispatch('resetAuthUserDetail');

    helper.check()
        .then(response => {

            // Initialize toastr notification
            helper.notification();
            if(helper.getConfig('failed_install') && to.fullPath != '/install') {
                pageLoader.hide();
                return next({ path: '/install' })
            }

            // Check for IP Restriction; If restricted IP found, redirect to "/ip-restricted" route
            if(helper.getConfig('ip_filter') && localStorage.getItem('ip_restricted') && to.fullPath != '/ip-restricted') {
                pageLoader.hide();
                return next({ path: '/ip-restricted' })
            }

            // Check for Maintenance mode; If maintenance mode is on, redirect to "/maintenance" route
            if(helper.isAuth() && !helper.hasRole('admin') && helper.getConfig('maintenance_mode') && to.fullPath != '/maintenance') {
                pageLoader.hide();
                return next({ path: '/maintenance' })
            }

            if (to.matched.some(m => m.meta.validate)){
                const m = to.matched.find(m => m.meta.validate);

                // Check for authentication; If no, redirect to "/login" route
                if (m.meta.validate.indexOf('auth') > -1){
                    if(!helper.isAuth()){
                        toastr.error(i18n.auth.auth_required);
                        pageLoader.hide();
                        return next({ path: '/login' })
                    }
                }

                // Check for two factor security; If enabled, redirect to "/auth/security" route after login
                if (m.meta.validate.indexOf('two_factor') > -1){
                    if(helper.getConfig('two_factor_security') && helper.getTwoFactorCode()){
                        pageLoader.hide();
                        return next({ path: '/auth/security' })
                    }
                }

                // Check for screen lock; If enabled, redirect to "/auth/lock" route after screen lock timeout
                if (m.meta.validate.indexOf('lock_screen') > -1){
                    if(helper.getConfig('lock_screen') && helper.isScreenLocked()){
                        pageLoader.hide();
                        return next({ path: '/auth/lock' })
                    }
                }

                // Check for screen lock; If enabled, redirect to "/auth/lock" route after screen lock timeout
                if (m.meta.validate.indexOf('valid_license') > -1){
                    if(!helper.getConfig('l')){
                        toastr.error(i18n.license.invalid_license);
                        pageLoader.hide();
                        return next({ path: '/license' })
                    }
                }

                // Check for authentication; If authenticated, redirect to "/home" route
                if (m.meta.validate.indexOf('guest') > -1){
                    if(helper.isAuth()){
                        toastr.error(i18n.auth.guest_required);
                        pageLoader.hide();
                        return next({ path: '/home' })
                    }
                }
            }

        return next()
    })
    .catch(error => {
        // Authentication check fail, redirected back to "/login" route
        pageLoader.hide();
        store.dispatch('resetAuthUserDetail');
        return next({ path: '/login' })
    });
});

router.afterEach((to, from) => {
    pageLoader.hide();
});

export default router;
